var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.14932 9.95184C2.3593 8.57425 1.97784 7.4494 1.74783 6.30918C1.40765 4.62282 2.18614 2.97551 3.47578 1.9244C4.02084 1.48016 4.64566 1.63194 4.96797 2.21017L5.69562 3.5156C6.27238 4.55031 6.56075 5.06766 6.50355 5.61616C6.44636 6.16466 6.05744 6.61139 5.27961 7.50485L3.14932 9.95184ZM3.14932 9.95184C4.74839 12.7401 7.25783 15.2509 10.0493 16.8518M10.0493 16.8518C11.4269 17.6418 12.5517 18.0233 13.692 18.2533C15.3783 18.5935 17.0256 17.815 18.0767 16.5253C18.521 15.9803 18.3692 15.3555 17.791 15.0332L16.4855 14.3055C15.4508 13.7288 14.9335 13.4404 14.385 13.4976C13.8365 13.5548 13.3897 13.9437 12.4963 14.7215L10.0493 16.8518Z",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.4992de8bf13762894de3e053701ab6fd.svg";
export { ForwardRef as ReactComponent };